<div [formGroup]="element.group" [ngClass]="element?.theme?.outerWrap" class="form-group">
  <label [ngClass]="element?.theme?.labelClass">{{ element.elementOptions.label }}
    @if (element.validations?.required) {
      <b style="color:red">*</b>
    }
    @if (element?.tooltip?.display) {
      <span>
        <i class="fa fa-question-circle" aria-hidden="true" placement="{{element.tooltip.placement || 'right'}}"
        ngbTooltip="{{element.tooltip.text}}"></i>
      </span>
    } :</label>
    <select class="form-control" multiple [formControlName]="element.name" [attr.id]="element.id" [ngClass]="element?.theme?.control"
      >
      @if (element.elementOptions.placeholder) {
        <option value="">{{ element.elementOptions.placeholder }}</option>
      }
      @for (option of element.elementOptions.options; track option) {
        <option [value]="option.value">
          {{ option.label }}
        </option>
      }
    </select>

    @if (element.group.controls[this.element['name']].dirty && !element.group.controls[this.element['name']].pristine && (element.group.controls[this.element['name']].status === 'INVALID')) {
      <div class="alert alert-danger" role="alert">
        <rs-error-message [fieldForm]="element.group.controls[this.element['name']]" [field]="element"></rs-error-message>
      </div>
    }

  </div>
